import angular from 'angular'

angular.module('nominas.nomina')
  .service('NominasNominaBancosDetallado', NominasNominaBancosDetallado)

function NominasNominaBancosDetallado($q, $filter, $state, NominasNomina, NominasNominaEmpleados, NominasNominaSuministro, NominasNominaBancos, NominasNominaMovimientos) {
  this.get = get
  this.grid = grid

  function findSuministro(suministros, idEmpresa, idEmpleado) {
    return suministros.find(function (item) {
      return (item.id_empresa == idEmpresa && item.id_empleado == idEmpleado)
        || (item.ID_Empresa == idEmpresa && item.ID_Empleado == idEmpleado)
    })
  }

  function get(idEmpresa, idNomina) {
    let legacy = ['47', '48', '49', '50', '51', '52', '53', '56', '1056', '1053', '1052', '1051', '1050', '1049', '1048', '1047'].indexOf(idEmpresa) >= 0

    return $q.all({
      nominaEmpleados: NominasNominaEmpleados.get(idEmpresa, idNomina),
      nominaSuministro: NominasNominaSuministro.get(idEmpresa, idNomina),
      /*nominaSuministro: legacy ? NominasNominaSuministro.get(idEmpresa, idNomina) : NominasNominaMovimientos.get(idEmpresa, idNomina).then(function (response) {
       return response.data;
       }),*/
      nominaBancos: NominasNominaBancos.get(idEmpresa, idNomina),
    }).then(function ($resolve) {
      let capitalize = $filter('capitalize')

      return $resolve.nominaEmpleados.map(function (empleado, index) {
        let bancos = $resolve.nominaBancos[index].Bancos,
          suministro = findSuministro($resolve.nominaSuministro, empleado.ID_Empresa, empleado.ID_Empleado),
          Total_Pagar = 0

        // if (legacy) {
        Total_Pagar = suministro.Total
        angular.forEach(suministro.Deducciones, function (deduccion) {
          Total_Pagar -= angular.isNumber(deduccion.editado)
            ? deduccion.editado
            : deduccion.calculado
        })
        /*} else {
         Total_Pagar += suministro.neto_a_pagar;
         ["percepciones", "deducciones"].forEach(function (naturaleza) {
         angular.forEach(suministro[naturaleza], function (value) {
         Total_Pagar += value.importe * (naturaleza === "percepciones" ? 1 : -1);
         });
         });
         }*/

        return {
          ID_Empresa: empleado.ID_Empresa,
          ID_Empleado: empleado.ID_Empleado,
          ID_Departamento: empleado.ID_Departamento,
          Empresa: empleado.Empresa,
          Empleado: capitalize(empleado.Empleado, true),
          Departamento: empleado.Departamento,
          Status: empleado.Status,
          Total_Pagar: Total_Pagar,
          // Cuenta USD
          USD_Banco: bancos[0].Banco,
          USD_Cuenta: bancos[0].Cuenta,
          USD_CLABE: bancos[0].CLABE,
          USD_Sucursal: bancos[0].Sucursal,
          USD_Moneda: bancos[0].Moneda,
          USD_Notas: bancos[0].Notas,
          // Banco MXN1
          MXN1_Banco: bancos[1].Banco,
          MXN1_Cuenta: bancos[1].Cuenta,
          MXN1_CLABE: bancos[1].CLABE,
          MXN1_Sucursal: bancos[1].Sucursal,
          MXN1_Moneda: bancos[1].Moneda,
          MXN1_Notas: bancos[1].Notas,
          // Banco MXN2
          MXN2_Banco: bancos[2].Banco,
          MXN2_Cuenta: bancos[2].Cuenta,
          MXN2_CLABE: bancos[2].CLABE,
          MXN2_Sucursal: bancos[2].Sucursal,
          MXN2_Moneda: bancos[2].Moneda,
          MXN2_Notas: bancos[2].Notas,
        }
      })
    })
  }

  function grid(idEmpresa, idNomina) {
    return $q.all({
      nomina: NominasNomina.get(idEmpresa, idNomina),
      data: get(idEmpresa, idNomina),
    }).then(function ($resolve) {
      let nomina = $resolve.nomina,
        data = $resolve.data
      return {
        pinnedColumnCount: 2,
        enableColResize: true,
        rowSelection: 'single',
        columnDefs: [{
          headerName: 'Total',
          field: 'Total_Pagar',
          pinned: 'left',
          width: 90,
          minWidth: 80,
          cellRenderer: currencyRenderer,
        },
          {headerGroup: 'Cuenta USD', headerName: 'Banco', field: 'USD_Banco', width: 150, minWidth: 80},
          {headerGroup: 'Cuenta USD', headerName: 'Cuenta', field: 'USD_Cuenta', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta USD', headerName: 'CLABE', field: 'USD_CLABE', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta USD', headerName: 'Moneda', field: 'USD_Moneda', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta USD', headerName: 'Sucursal', field: 'USD_Sucursal', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta USD', headerName: 'Notas', field: 'USD_Notas', width: 100, minWidth: 80},

          {headerGroup: 'Cuenta MXN 1', headerName: 'Banco', field: 'MXN1_Banco', width: 150, minWidth: 80},
          {headerGroup: 'Cuenta MXN 1', headerName: 'Cuenta', field: 'MXN1_Cuenta', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta MXN 1', headerName: 'CLABE', field: 'MXN1_CLABE', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta MXN 1', headerName: 'Moneda', field: 'MXN1_Moneda', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta MXN 1', headerName: 'Sucursal', field: 'MXN1_Sucursal', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta MXN 1', headerName: 'Notas', field: 'MXN1_Notas', width: 100, minWidth: 80},

          {headerGroup: 'Cuenta MXN 2', headerName: 'Banco', field: 'MXN2_Banco', width: 150, minWidth: 80},
          {headerGroup: 'Cuenta MXN 2', headerName: 'Cuenta', field: 'MXN2_Cuenta', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta MXN 2', headerName: 'CLABE', field: 'MXN2_CLABE', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta MXN 2', headerName: 'Moneda', field: 'MXN2_Moneda', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta MXN 2', headerName: 'Sucursal', field: 'MXN2_Sucursal', width: 100, minWidth: 80},
          {headerGroup: 'Cuenta MXN 2', headerName: 'Notas', field: 'MXN2_Notas', width: 100, minWidth: 80},
        ],
        rowData: data,
        groupHeaders: true,
        groupUseEntireRow: false,
        groupKeys: nomina.ID_Moneda === '1' ? ['MXN1_Banco', 'Empresa'] : ['USD_Banco', 'Empresa'],
        groupDefaultExpanded: true,
        groupAggFields: ['Total_Pagar'],
        icons: {
          groupExpanded: '<i class="fa fa-chevron-down fa-fw"></i>',
          groupContracted: '<i class="fa fa-chevron-right fa-fw"></i>',
        },
        groupColumnDef: {
          headerName: 'Banco > Empresa > Empleado',
          field: 'Empleado',
          width: 350,
          minWidth: 200,
          cellRenderer: {
            renderer: 'group',
            padding: 10,
            innerRenderer: function (params) {
              if (params.node.group) {
                return (params.node.field === 'Departamento'
                  ? 'Depto. '
                  : '')
                  + params.node.key
              } else {
                let link = $state.href('empleado.info.personal', {
                  idEmpresa: params.data.ID_Empresa,
                  idEmpleado: params.data.ID_Empleado,
                })

                return '<a class="link link-primary" href="' + link + '" target="_blank" title="Informaci&oacute;n del Kardex">' +
                  params.data.ID_Empleado
                  + '</a>'
                  + ' &mdash; ' + params.value
              }
            },
          },
        },
      }

      function currencyRenderer(params) {
        return '<div>$<span style="float:right">' + $filter('currency')(params.value, '') + '</span></div>'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Bancos/Detallado.js